import {config as numberColumnConfig} from '../../common/NumberColumn';

export const prop = 'pATot';
export const id = 'preparerAssignments';

export const config = (labels) => numberColumnConfig({fullId: id, label: labels.preparerAssignments, prop});
